enum ShiftDeclinedReason {
        BOOKING_DECLINED_REASON_UNDEFINED = 0,
        BOOKING_DECLINED_REASON_TOO_SHORT_NOTICE = 1,
        BOOKING_DECLINED_REASON_UNAVAILABLE = 2,
        BOOKING_DECLINED_REASON_WORKING_ELSEWHERE = 3,
        BOOKING_DECLINED_REASON_PAY_RATE = 4,
        BOOKING_DECLINED_REASON_TRANSPORT = 5,
        BOOKING_DECLINED_REASON_POSITION = 6,
}

export default ShiftDeclinedReason;